var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcBookVoilet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 44,
    viewBox: "0 0 57 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.4331 43.0222C25.4903 43.3942 26.6258 42.6208 26.6258 41.5049V4.56162C26.6258 4.15049 26.4692 3.73936 26.1363 3.48485C24.2177 1.95778 19.8127 0 14.096 0C9.15261 0 4.53226 1.30192 1.77179 2.35912C0.665645 2.78983 0 3.88619 0 5.07065V41.3189C0 42.4838 1.25298 43.2963 2.35912 42.9341C5.44262 41.9062 10.3273 40.7218 14.096 40.7218C17.4144 40.7218 21.8292 42.0922 24.4331 43.0222ZM31.9509 43.0222C34.5548 42.0922 38.9696 40.7218 42.288 40.7218C46.0567 40.7218 50.9414 41.9062 54.0249 42.9341C55.131 43.3061 56.384 42.4838 56.384 41.3189V5.07065C56.384 3.88619 55.7184 2.78983 54.6122 2.36891C51.8518 1.30192 47.2314 0 42.288 0C36.5713 0 32.1663 1.95778 30.2477 3.48485C29.9246 3.73936 29.7582 4.15049 29.7582 4.56162V41.5049C29.7582 42.6208 30.9035 43.3942 31.9509 43.0222Z",
    fill: "#A855F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBookVoilet);
export default __webpack_public_path__ + "static/media/ic_book_voilet.55469660f6108d5222f5809325e85696.svg";
export { ForwardRef as ReactComponent };